import Keycloak from 'keycloak-js';

export const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8080',
  realm: import.meta.env.VITE_KEYCLOAK_REALM ?? 'te-presta',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'aid-frontend',
});

export const KEYCLOAK_INIT_OPTIONS = {
  onLoad: 'login-required' as const,
  silentCheckSsoFallback: false,
  checkLoginIframe: false,
};
